import * as React from "react";
import { ListItemText, ListItemTextProps, styled } from "@mui/material";
import { CONDENSED_FONT_LT } from "fe-web-components/styles/typography";
import { QualifiedFeature } from "fe-common/graphql";
import { getQFAndRefinementsLines } from "fe-common/logic";
import { RosebudColorMap } from "../rosebud/rosebudColorMap";
import { MobileView } from "../../../util/aKaunGeneralUtil";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";

//region [[ Styles ]]
const QualifiedFeatureListItemTextView = styled(ListItemText)({});
const ChiefComplaintLink = styled("span")(({ theme }) => ({
  [theme.breakpoints.down(MobileView)]: {
    color: "white",
  },
  cursor: "pointer",
}));

const ChiefComplaintPresenterView = styled("span")(({ theme }) => ({
  fontSize: "17px",
  // TODO: chane color to rosebud color map
  color: RosebudColorMap.green2,
  textDecoration: "none",
  fontWeight: 400,
  [theme.breakpoints.down(MobileView)]: {
    fontSize: "16px",
    fontWeight: 500,
    color: KahunColorMap.DefaultLight,
  },
}));

const FindingRefinementsItemTypography = styled("span")(({ theme }) => ({
  fontSize: "14px",
  fontFamily: CONDENSED_FONT_LT,
  // TODO: chagne color to rosebud color map
  color: "#494949",
  [theme.breakpoints.down(MobileView)]: {
    color: "white",
    fontWeight: 500,
  },
}));

//endregion [[ Styles ]]

//region [[ Props ]]
export interface QualifiedFeatureListItemTextProps extends ListItemTextProps {
  className?: string;
  onEditFeature?: () => void;
  qualifiedFeature: QualifiedFeature[];
  hideRefinement?: boolean;
  emptyText?: string;
  maxChars?: number;
}
//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const QualifiedFeatureListItemText = ({
  className,
  qualifiedFeature,
  onEditFeature,
  hideRefinement,
  emptyText,
  maxChars,
  ...listItemTextProps
}: QualifiedFeatureListItemTextProps) => {
  //TODO: Change for Multiple CF
  const [chiefComplaint, qualifiers] = getQFAndRefinementsLines(
    qualifiedFeature?.length ? qualifiedFeature[0] : null,
  );

  const handleFeatureClick = (e) => {
    if (onEditFeature) {
      e.stopPropagation();
      onEditFeature();
    }
  };

  return (
    <QualifiedFeatureListItemTextView
      className={className}
      primary={
        <ChiefComplaintPresenterView className={"qf-text"}>
          <ChiefComplaintLink
            className={"qf-link"}
            onClick={handleFeatureClick}
          >
            {chiefComplaint || emptyText}
          </ChiefComplaintLink>
        </ChiefComplaintPresenterView>
      }
      secondary={
        hideRefinement ? null : (
          // refinement
          <FindingRefinementsItemTypography className={"qf-refinements-text"}>
            {maxChars && qualifiers.length > maxChars
              ? qualifiers.substring(0, maxChars) + "..."
              : qualifiers}
          </FindingRefinementsItemTypography>
        )
      }
      {...listItemTextProps}
    />
  );
};
